<template>
    <span class="email-unsubscribe-modal">
        <span id="email-unsubscribe-modal-button" @click="openModal"></span>
        <div class="modal-backdrop" v-show="isModalVisible">
            <div class="modal-container" :name="modalId" style="align-items: center; max-width: 610px; margin: auto; padding-top: 5%;">
                
                <a @click="closeModal" class="x-button"><img src="../../../../public/img/close_x.svg" alt="X" /></a>
                <div v-if="modalInteger === 1" class="inner-modal modal-fade">
                    <div class="head-one row">
                        <div class="char-text title">Onboard Email Notifications</div>
                    </div>
                    <div class="modal-body">
                        <div class="light-text desc">
                            You are currently listed as a resident at {{marketingName ? marketingName : projectName }} and are set to receive crucial amenity related notifications from Onboard.
                        </div>
                        <div class="light-text desc"> 
                            If you wish to no longer receive internet & media related notifications, please enter your email below
                        </div>
                        <div class="unsubscribe">
                            <form class="unsub-form" @submit.prevent="submit" method="POST">
                                <div class="input-div" :class="{'has-error': errors.has('email')}">
                                    
                                    <input v-if="popup == 2 || popup == 1" name="email" class="input-style email" id="email" type="email" placeholder=" "
                                        v-model="email" required :style="{borderColor: 'red', marginBottom: 'auto'}"/>
                                    <input v-else name="email" class="input-style email" id="email" type="email" placeholder=" "
                                    v-model="email" required/>
                                    <label class="label-form" for="email">Email</label>
                                    <span v-show="errors.has('email')" class="help-block">
                                        {{ errors.first('email') }}
                                    </span>
                                    
                                    <div v-if="popup == 2" class="popup">That email does not match our records.</div>
                                    <div v-else-if="popup == 1" class="popup">That email is already unsubscribed.</div>
                                    <span v-else></span>
                                </div>
                                    <button 
                                    :disabled="email == null || isLoading" 
                                    type="submit" class="subscribe-button" 
                                    :style="email == null || isLoading ? 
                                    {backgroundColor:this.marketingPrimary, color: 'white', opacity: '.3'}
                                     : 
                                    {backgroundColor:this.marketingPrimary, color: 'white', opacity: 1}">
                                    Unsubscribe
                                    </button>
                                                                   
                            </form>
                            
                        </div>
                        <a :style="{color: this.marketingPrimary, cursor: 'pointer', marginTop: '5px', fontSize: '14px'}" @click="closeModal">
                            Keep me enrolled
                        </a>
                        
                    </div>
                </div>
                
                <div v-else class="inner-modal modal-fade">
                    <div class="head-one row">
                        <div class="char-text title">Onboard Email Notifications</div>
                    </div>
                    <div class="modal-body">
                        <div class="light-text desc">
                           You have been unsubscribed from internet & media related email notifications. You can change your subscription settings in your dashboard
                        </div>
                        <a class="subscribe-button" @click="closeModal" :style="{backgroundColor: this.marketingPrimary, color: 'white', cursor: 'pointer'}">
                            Close
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
    import Vue from "vue";
    import VueMask from 'v-mask'
    Vue.use(VueMask);
    export default {
        props: {
            modalId: {
                default: Math.random().toString(),
                type: String
            },
            projectName: {
                required: true,
                type: String
            },
            marketingName: {
                required: false,
              type: String
            },
            projectSlug: {
                required: true,
                type: String,
            },
            marketingPrimary: {
                required: true,
                type: String,
            },
            contactId: {
                required: true,
                type: String,
            },
            
        },
        computed: {},
        data(){
            return {
                isModalVisible: false,
                modalInteger: 1,
                email: null,
                popup: 0,
                isLoading: false,
            }
        },
        methods: {
            closeModal(){
                this.isModalVisible = false;
            },
            openModal(){
                this.isModalVisible = true;
            },
            submit(){
                this.popup = false;
                this.isLoading = true;
                return this.$validator.validateAll()
                .then((valid) => {
                    if (valid) {
                        return axios.post( 'api/contact-email/unsubscribe', {
                            unsubscribeUserId: this.contactId,
                            unsubscribeUserEmail: this.email
                        })
                        .then((response) => {
                            if (!response.data){
                                alert("There was an error please try again");
                            } else {
                                this.modalInteger = 2;
                            }
                        })
                        .catch((error)=> {
                            if (error.response.data == 'Already Unsubscribed') {
                                this.popup = 1;
                            } else if (error.response.data == "No Email") {
                                this.popup = 2;
                            }
                        })
                        .finally(() => {
                            this.isLoading = false
                        })
                    }
                })              
            }
        }
    }
</script>